import React, { createContext, useContext } from 'react';
import { crzDataQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import { useHasCrzResults } from '@gov-nx/module/service';
import type { ServiceCode } from '../../definitions/codes';
import type { ZbrojniListSeznamContextTypes } from './context.types';
import { useIdentity } from '@gov-nx/auth/common';

export const ZbrojniListSeznamContext =
	createContext<ZbrojniListSeznamContextTypes | null>(null);

export interface ZbrojniListSeznamContextProviderProps {
	children: React.ReactNode;
	code: ServiceCode;
}

export const ZbrojniListSeznamContextProvider = ({
	children,
	code,
}: ZbrojniListSeznamContextProviderProps) => {
	const { t } = useLocale(code);
	const { axiosInstance } = useAxiosInstance();
	const loginInfo = useIdentity();

	const query = usePoQuery({
		queryKey: ['zbrojni-crz-detail'],
		queryFn: () => crzDataQuery(axiosInstance),
	});

	const hasCrzResults = useHasCrzResults(query.data);

	return (
		<ZbrojniListSeznamContext.Provider
			value={{
				isCrzResultLoading: query.isLoading,
				hasCrzResult: hasCrzResults,
				strings: {
					title: t('zbrojni-list.seznam.nadpis'),
					subtitle: t('zbrojni-list.seznam.podnadpis'),
				},
				loginInfo,
			}}>
			{children}
		</ZbrojniListSeznamContext.Provider>
	);
};

export const useZbrojniListSeznamContext = () =>
	useContext(ZbrojniListSeznamContext) as ZbrojniListSeznamContextTypes;
